import produce, { castDraft, } from 'immer';
import { TimeSeriesActionType, } from './actions';
const tsIdsByHomeIdByTSDBModuleIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case TimeSeriesActionType.SET_ALL_TIME_SERIES_INFO:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.homeId] || {};
                draft[actualAction.homeId] = temp;
                // We only need to store the list of timeSeries' id but not the whole timeSeries info object. The objects will be stored
                // in the tsInfoByIdByHomeIdByTSDBModuleId state
                temp[actualAction.tsdbModuleId] = actualAction.timeSeries.map((timeSeriesInfo) => {
                    return timeSeriesInfo.id;
                });
            });
        case TimeSeriesActionType.CLEAR_TIME_SERIES:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const timeSeriesByHomeId = draft[actualAction.homeId];
                if (timeSeriesByHomeId) {
                    delete timeSeriesByHomeId[actualAction.tsdbModuleId];
                }
            });
        default:
            return currentState;
    }
};
const tsInfoByIdByHomeIdByTSDBModuleIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case TimeSeriesActionType.SET_ALL_TIME_SERIES_INFO:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.homeId] || {};
                draft[actualAction.homeId] = temp;
                const temp2 = temp[actualAction.tsdbModuleId] || {};
                temp[actualAction.tsdbModuleId] = temp2;
                actualAction.timeSeries.forEach((timeSeriesInfo) => {
                    temp2[timeSeriesInfo.id] = timeSeriesInfo;
                });
            });
        case TimeSeriesActionType.SET_TIME_SERIES_INFO:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.homeId] || {};
                draft[actualAction.homeId] = temp;
                const temp2 = temp[actualAction.tsdbModuleId] || {};
                temp[actualAction.tsdbModuleId] = temp2;
                temp2[actualAction.timeSeriesId] = castDraft(actualAction.timeSeries);
            });
        default:
            return currentState;
    }
};
const tsRangeByIdByHomeIdByTSDBModuleIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case TimeSeriesActionType.SET_TIME_SERIES_RANGE:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.homeId] || {};
                draft[actualAction.homeId] = temp;
                const temp2 = temp[actualAction.tsdbModuleId] || {};
                temp[actualAction.tsdbModuleId] = temp2;
                temp2[actualAction.timeSeriesId] = castDraft(actualAction.range);
            });
        default:
            return currentState;
    }
};
const tsDataByIdByHomeIdByTSDBModuleIdBySearchParamsReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case TimeSeriesActionType.SET_TIME_SERIES_DATA:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.homeId] || {};
                draft[actualAction.homeId] = temp;
                const temp2 = temp[actualAction.tsdbModuleId] || {};
                temp[actualAction.tsdbModuleId] = temp2;
                const temp3 = temp2[actualAction.timeSeriesId] || {};
                temp2[actualAction.timeSeriesId] = temp3;
                temp3[actualAction.searchParams] = castDraft(actualAction.data);
            });
        case TimeSeriesActionType.CLEAR_TIME_SERIES_DATA:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const timeSeriesByHomeId = draft[actualAction.homeId];
                const timeSeriesByHomeIdBySmartModuleId = timeSeriesByHomeId === null || timeSeriesByHomeId === void 0 ? void 0 : timeSeriesByHomeId[actualAction.tsdbModuleId];
                if (timeSeriesByHomeIdBySmartModuleId) {
                    timeSeriesByHomeIdBySmartModuleId[actualAction.timeSeriesId] = {};
                }
            });
        default:
            return currentState;
    }
};
const tsRawDataByIdByHomeIdByTSDBModuleIdBySearchParamsReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case TimeSeriesActionType.SET_TIME_SERIES_RAW_DATA:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.homeId] || {};
                draft[actualAction.homeId] = temp;
                const temp2 = temp[actualAction.tsdbModuleId] || {};
                temp[actualAction.tsdbModuleId] = temp2;
                const temp3 = temp2[actualAction.timeSeriesId] || {};
                temp2[actualAction.timeSeriesId] = temp3;
                temp3[actualAction.searchParams] = castDraft(actualAction.data);
            });
        case TimeSeriesActionType.CLEAR_TIME_SERIES_DATA:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const timeSeriesByHomeId = draft[actualAction.homeId];
                const timeSeriesByHomeIdBySmartModuleId = timeSeriesByHomeId === null || timeSeriesByHomeId === void 0 ? void 0 : timeSeriesByHomeId[actualAction.tsdbModuleId];
                if (timeSeriesByHomeIdBySmartModuleId) {
                    timeSeriesByHomeIdBySmartModuleId[actualAction.timeSeriesId] = {};
                }
            });
        default:
            return currentState;
    }
};
const tsCollectionIdsByHomeIdByTSDBModuleIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case TimeSeriesActionType.SET_ALL_TIME_SERIES_COLLECTION_INFO:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.homeId] || {};
                draft[actualAction.homeId] = temp;
                // We only need to store the list of timeSeries collection's id but not the whole timeSeries collection info object.
                // The objects will be stored in the tsCollectionInfoByIdByHomeIdByTSDBModuleId state
                temp[actualAction.tsdbModuleId] = actualAction.collections.map((collectionInfo) => {
                    return collectionInfo.id;
                });
            });
        case TimeSeriesActionType.CLEAR_TIME_SERIES_COLLECTIONS:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const collectionsByHomeId = draft[actualAction.homeId];
                if (collectionsByHomeId) {
                    delete collectionsByHomeId[actualAction.tsdbModuleId];
                }
            });
        default:
            return currentState;
    }
};
const tsCollectionInfoByIdByHomeIdByTSDBModuleIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case TimeSeriesActionType.SET_ALL_TIME_SERIES_COLLECTION_INFO:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.homeId] || {};
                draft[actualAction.homeId] = temp;
                const temp2 = temp[actualAction.tsdbModuleId] || {};
                temp[actualAction.tsdbModuleId] = temp2;
                actualAction.collections.forEach((collectionInfo) => {
                    temp2[collectionInfo.id] = castDraft(collectionInfo);
                });
            });
        case TimeSeriesActionType.SET_TIME_SERIES_COLLECTION_INFO:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.homeId] || {};
                draft[actualAction.homeId] = temp;
                const temp2 = temp[actualAction.tsdbModuleId] || {};
                temp[actualAction.tsdbModuleId] = temp2;
                temp2[actualAction.collectionId] = castDraft(actualAction.collection);
            });
        default:
            return currentState;
    }
};
const tsCollectionRangeByIdByHomeIdByTSDBModuleIdReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case TimeSeriesActionType.SET_TIME_SERIES_COLLECTION_RANGE:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.homeId] || {};
                draft[actualAction.homeId] = temp;
                const temp2 = temp[actualAction.tsdbModuleId] || {};
                temp[actualAction.tsdbModuleId] = temp2;
                temp2[actualAction.collectionId] = castDraft(actualAction.range);
            });
        default:
            return currentState;
    }
};
const tsCollectionDataByIdByHomeIdByTSDBModuleIdBySearchParamsReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case TimeSeriesActionType.SET_TIME_SERIES_COLLECTION_DATA:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.homeId] || {};
                draft[actualAction.homeId] = temp;
                const temp2 = temp[actualAction.tsdbModuleId] || {};
                temp[actualAction.tsdbModuleId] = temp2;
                const temp3 = temp2[actualAction.collectionId] || {};
                temp2[actualAction.collectionId] = temp3;
                temp3[actualAction.searchParams] = castDraft(actualAction.data);
            });
        case TimeSeriesActionType.CLEAR_TIME_SERIES_COLLECTION_DATA:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const collectionsByHomeId = draft[actualAction.homeId];
                const collectionByHomeIdBySmartModuleId = collectionsByHomeId === null || collectionsByHomeId === void 0 ? void 0 : collectionsByHomeId[actualAction.tsdbModuleId];
                if (collectionByHomeIdBySmartModuleId) {
                    collectionByHomeIdBySmartModuleId[actualAction.collectionId] = {};
                }
            });
        default:
            return currentState;
    }
};
const tsCollectionRawDataByIdByHomeIdByTSDBModuleIdBySearchParamsReducer = (currentState, action) => {
    const { type } = action;
    switch (type) {
        case TimeSeriesActionType.SET_TIME_SERIES_COLLECTION_RAW_DATA:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const temp = draft[actualAction.homeId] || {};
                draft[actualAction.homeId] = temp;
                const temp2 = temp[actualAction.tsdbModuleId] || {};
                temp[actualAction.tsdbModuleId] = temp2;
                const temp3 = temp2[actualAction.collectionId] || {};
                temp2[actualAction.collectionId] = temp3;
                temp3[actualAction.searchParams] = castDraft(actualAction.data);
            });
        case TimeSeriesActionType.CLEAR_TIME_SERIES_COLLECTION_DATA:
            return produce(currentState, (draft) => {
                const actualAction = action;
                const collectionsByHomeId = draft[actualAction.homeId];
                const collectionByHomeIdBySmartModuleId = collectionsByHomeId === null || collectionsByHomeId === void 0 ? void 0 : collectionsByHomeId[actualAction.tsdbModuleId];
                if (collectionByHomeIdBySmartModuleId) {
                    collectionByHomeIdBySmartModuleId[actualAction.collectionId] = {};
                }
            });
        default:
            return currentState;
    }
};
export const timeSeriesStateReducer = (currentState, action) => {
    return produce(currentState, (draft) => {
        draft.tsIdsByHomeIdByTSDBModuleId = castDraft(tsIdsByHomeIdByTSDBModuleIdReducer(currentState.tsIdsByHomeIdByTSDBModuleId, action));
        draft.tsInfoByIdByHomeIdByTSDBModuleId = tsInfoByIdByHomeIdByTSDBModuleIdReducer(currentState.tsInfoByIdByHomeIdByTSDBModuleId, action);
        draft.tsRangeByIdByHomeIdByTSDBModuleId = tsRangeByIdByHomeIdByTSDBModuleIdReducer(currentState.tsRangeByIdByHomeIdByTSDBModuleId, action);
        draft.tsDataByIdByHomeIdByTSDBModuleIdBySearchParams = castDraft(tsDataByIdByHomeIdByTSDBModuleIdBySearchParamsReducer(currentState.tsDataByIdByHomeIdByTSDBModuleIdBySearchParams, action));
        draft.tsRawDataByIdByHomeIdByTSDBModuleIdBySearchParams = castDraft(tsRawDataByIdByHomeIdByTSDBModuleIdBySearchParamsReducer(currentState.tsRawDataByIdByHomeIdByTSDBModuleIdBySearchParams, action));
        draft.tsCollectionIdsByHomeIdByTSDBModuleId = castDraft(tsCollectionIdsByHomeIdByTSDBModuleIdReducer(currentState.tsCollectionIdsByHomeIdByTSDBModuleId, action));
        draft.tsCollectionInfoByIdByHomeIdByTSDBModuleId = castDraft(tsCollectionInfoByIdByHomeIdByTSDBModuleIdReducer(currentState.tsCollectionInfoByIdByHomeIdByTSDBModuleId, action));
        draft.tsCollectionRangeByIdByHomeIdByTSDBModuleId = tsCollectionRangeByIdByHomeIdByTSDBModuleIdReducer(currentState.tsCollectionRangeByIdByHomeIdByTSDBModuleId, action);
        draft.tsCollectionDataByIdByHomeIdByTSDBModuleIdBySearchParams = castDraft(tsCollectionDataByIdByHomeIdByTSDBModuleIdBySearchParamsReducer(currentState.tsCollectionDataByIdByHomeIdByTSDBModuleIdBySearchParams, action));
        draft.tsCollectionRawDataByIdByHomeIdByTSDBModuleIdBySearchParams = castDraft(tsCollectionRawDataByIdByHomeIdByTSDBModuleIdBySearchParamsReducer(currentState.tsCollectionRawDataByIdByHomeIdByTSDBModuleIdBySearchParams, action));
    });
};
